import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MainPage from './components/MainPage';
import { GoogleOAuthProvider } from "@react-oauth/google"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId='1039185983165-f80pvpl6ejl3jtrdjevv4tkcop418d35.apps.googleusercontent.com'>
    <React.StrictMode>
      <MainPage />
    </React.StrictMode>
  </GoogleOAuthProvider>
);
